// extracted by mini-css-extract-plugin
export default {"MetadataFooterContainer":"MetadataFooter-module__MetadataFooterContainer--omn3p"};